/* ################################################################### */
/* FUNCTION (STICKY FOOTER) ########################################## */
/* ################################################################### */
function stickyFooter()
{
	if(jQuery('#footer').hasClass('is-sticky'))
	{
		jQuery('#wrapper, #gallery').css(
		{
			'padding-bottom' : jQuery('#footer').outerHeight(true),
			'box-sizing'     : 'border-box'
		});
	}
}

/*
function stickyFooter()
{
	jQuery('#footer').attr('style', '');

	var h_body          = jQuery('body').height();
		h_wrapper       = jQuery('#wrapper').outerHeight(true);
		marginTopFooter = parseInt(jQuery('#footer').css('margin-top'));

	if(h_body > h_wrapper)
		jQuery('#footer').css('margin-top', h_body - h_wrapper + marginTopFooter);
}
*/
